"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideCreateSavedRepliesModal = exports.showCreateSavedRepliesModal = exports.hideSidebarPreferencesModal = exports.showSidebarPreferencesModal = exports.hideOnBoardingV2Modal = exports.showOnBoardingV2Modal = exports.hideFeedbackModal = exports.showFeedbackModal = exports.FeedbackType = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var FeedbackType;
(function (FeedbackType) {
  FeedbackType[FeedbackType["SALES"] = 0] = "SALES";
  FeedbackType[FeedbackType["SERVICE"] = 1] = "SERVICE";
})(FeedbackType = exports.FeedbackType || (exports.FeedbackType = {}));
exports.showFeedbackModal = (0, typesafe_actions_1.createStandardAction)('@modal/SHOW_FEEDBACK_MODAL')();
exports.hideFeedbackModal = (0, typesafe_actions_1.createStandardAction)('@modal/HIDE_FEEDBACK_MODAL')();
exports.showOnBoardingV2Modal = (0, typesafe_actions_1.createStandardAction)('@modal/SHOW_ONBOARDING_V2_MODAL')();
exports.hideOnBoardingV2Modal = (0, typesafe_actions_1.createStandardAction)('@modal/HIDE_ONBOARDING_V2_MODAL')();
exports.showSidebarPreferencesModal = (0, typesafe_actions_1.createStandardAction)('@modal/SHOW_SIDEBAR_PREFERENCES_MODAL')();
exports.hideSidebarPreferencesModal = (0, typesafe_actions_1.createStandardAction)('@modal/HIDE_SIDEBAR_PREFERENCES_MODAL')();
exports.showCreateSavedRepliesModal = (0, typesafe_actions_1.createStandardAction)('@modal/SHOW_CREATE_SAVED_REPLIES_MODAL')();
exports.hideCreateSavedRepliesModal = (0, typesafe_actions_1.createStandardAction)('@modal/HIDE_CREATE_SAVED_REPLIES_MODAL')();